<template>
  <div class="lang-switcher">
    <!-- 语言切换按钮 -->
    <button 
      class="lang-btn" 
      @click="togglePopup"
      :title="$t('common.switchLanguage')"
    >
      <img src="/assets/img/lang_switcher.svg" alt="Language" />
    </button>

    <!-- 语言选择弹窗 -->
    <div v-if="showPopup" class="lang-popup" @click.self="closePopup">
      <div class="lang-popup-content">
        <div class="lang-option" @click="selectLang('en')">
          <span class="lang-label">English</span>
          <span v-if="currentLang === 'en'" class="lang-check">✓</span>
        </div>
        <div class="lang-option" @click="selectLang('zh')">
          <span class="lang-label">中文</span>
          <span v-if="currentLang === 'zh'" class="lang-check">✓</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LangSwitcher',
  data() {
    return {
      currentLang: this.$i18n.locale,
      showPopup: false
    }
  },
  methods: {
    togglePopup() {
      this.showPopup = !this.showPopup
    },
    closePopup() {
      this.showPopup = false
    },
    selectLang(lang) {
      this.$i18n.locale = lang
      this.currentLang = lang
      this.showPopup = false
      
      // 保存到 localStorage
      localStorage.setItem('preferred_lang', lang)
      
      // English is the canonical default, so only non-default languages stay in the URL.
      const query = { ...this.$route.query }
      if (lang === 'en') {
        delete query.lang
      } else {
        query.lang = lang
      }
      this.$router.replace({ query })
    },
    handleOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.closePopup()
      }
    }
  },
  created() {
    // 监听 i18n locale 变化
    this.$watch('$i18n.locale', (newVal) => {
      this.currentLang = newVal
    })
    
    // 点击外部关闭弹窗
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  }
}
</script>

<style scoped>
.lang-switcher {
  position: relative;
  display: flex;
  align-items: center;
}

.lang-btn {
  background: transparent;
  border: none;
  outline: none;
  width: 40px;
  height: 40px;
  padding: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.lang-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: scale(1.05);
}

.lang-btn::-moz-focus-inner {
  border: 0;
}

.lang-btn img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

/* 弹窗样式 */
.lang-popup {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: 9999;
  animation: fadeIn 0.2s ease;
}

.lang-popup-content {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 8px;
  min-width: 140px;
}

.lang-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.lang-option:hover {
  background-color: #f5f5f5;
}

.lang-option:first-child:hover {
  background-color: #f0f7ff;
}

.lang-option:last-child:hover {
  background-color: #fff5f5;
}

.lang-label {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.lang-check {
  font-size: 16px;
  color: #1890ff;
  font-weight: bold;
}

/* 动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
